import React, { useState, useEffect } from 'react';
import './index.scss';
import { StudyAbroadMateProfileModal } from '@/Components/Product';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: {
        "Start now": "Start now"
    },
    id: {
        "Start now": "Mulai sekarang"
    },
    ko: {
        "Start now": "지금 시작"
    },
    vn: {
        "Start now": "Bắt đầu ngay"
    }
};

const StudyAbroadMateProduct: React.FC = () => {
    const [, forceUpdate] = useState({});
    const t = tLoader(translations);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    const openForm = () => {
        setShowForm(true);
        window.history.pushState({ formOpen: true }, '', window.location.href);
    };

    const closeForm = () => {
        setShowForm(false);
        if (window.history.state?.formOpen) {
            window.history.back();
        }
    };

    useEffect(() => {
        const handlePopState = (e: PopStateEvent) => {
            if (!e.state?.formOpen && showForm) {
                setShowForm(false);
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showForm]);

    return (
        <div className="study-abroad-mate-page">
            <div className="image-container">
                <img src="https://static.koreanmate.app/product/studyabroad/main_background.png" alt="Main background" className="background-image" />

                <div className="maintitle-overlay">
                    <img src="https://static.koreanmate.app/product/studyabroad/maintitle.png" alt="GKS Seminar" className="maintitle-logo" />
                </div>
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page02.jpg" alt="Program Overview" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page03.jpg" alt="Benefits" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page04.jpg" alt="Requirements" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page05.jpg" alt="Application Process" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page06.jpg" alt="Timeline" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page07.jpg" alt="Success Stories" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page08.jpg" alt="FAQ" className="page-image" />
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page09.jpg" alt="Catchprhase" className="page-image" />
            </div>

            <div className="page-container">
                <button className="page-button" onClick={openForm}>
                    <img src="https://static.koreanmate.app/product/studyabroad/page10.jpg" alt="Register Now" className="page-image" />
                </button>
            </div>

            <div className="page-container">
                <img src="https://static.koreanmate.app/product/studyabroad/page11.jpg" alt="Contact" className="page-image" />
            </div>

            <StudyAbroadMateProfileModal
                isOpen={showForm}
                onClose={closeForm}
            />

            <div className="fab-container" onClick={openForm}>
                <button className="fab-button-text">
                    <span className="fab-text">{t("Start now")}</span>
                </button>
            </div>
        </div>
    );
};

export default StudyAbroadMateProduct;